import { Trans } from 'react-i18next';

import { FormContextValues } from '@dreryk/react-common';
import {
   Link,
   LinkSize,
   LinkTarget,
   Notification,
   NotificationSize,
   NotificationType,
   RadioGroup,
   RadioGroupItem,
   StyledFlex,
} from '@dreryk/react-components';

import { nfzLoginTranslationKeys } from '../../../../translations';

export type MfaStategy = 'SECRET' | 'TOTP';

const HELP_CENTER_LINK =
   'https://centrumpomocy.egabinet.dreryk.pl/pierwsze-kroki/konfiguracja-konta-i-placowki/jak-skonfigurowac-kod-sekret-dla-ewus-mfa';
const MFA_STRATEGY_FIELD_NAME = 'mfaStrategy';

const MFA_STRATEGY_RADIO_ITEMS: RadioGroupItem<MfaStategy>[] = [
   {
      id: 'SECRET',
      label: nfzLoginTranslationKeys.mfaStrategy.map.SECRET,
   },
   {
      id: 'TOTP',
      label: nfzLoginTranslationKeys.mfaStrategy.map.TOTP,
   },
];

export type MfaStrategyFormBeanPart<VALUE extends MfaStategy | null = MfaStategy | null> = {
   [MFA_STRATEGY_FIELD_NAME]: VALUE;
};

type MfaStrategyFieldProps = Pick<FormContextValues<MfaStrategyFormBeanPart<MfaStategy | null>>, 'register'>;

export const MfaStrategyField = (props: MfaStrategyFieldProps): JSX.Element => {
   return (
      <StyledFlex direction={'column'} gap={8}>
         <RadioGroup<MfaStategy>
            label={nfzLoginTranslationKeys.mfaStrategy.label}
            testId={MFA_STRATEGY_FIELD_NAME}
            items={MFA_STRATEGY_RADIO_ITEMS}
            controller={props.register(MFA_STRATEGY_FIELD_NAME)}
            defaultValue={null}
         />

         <Notification
            testId={'helpCenter'}
            type={NotificationType.INFO}
            size={NotificationSize.SMALLER}
            label={
               <Trans
                  i18nKey={nfzLoginTranslationKeys.mfaStrategy.information.text}
                  components={{
                     link: (
                        <Link
                           testId={'helpCenter'}
                           label={nfzLoginTranslationKeys.mfaStrategy.information.helpCenter}
                           target={LinkTarget.BLANK}
                           block={false}
                           size={LinkSize.SMALL}
                           href={HELP_CENTER_LINK}
                        />
                     ),
                  }}
               />
            }
         />
      </StyledFlex>
   );
};
